import React from 'react';
import '../styles/familyFinder.css';

const FamilyFinderLayout = ({
  header,
  topBanner,
  genogram,
  roster,
  search,
  contactTimeline,
  auditTrail
}) => {
  return (
    <div className="family-finder-shell">
      {header && <div className="family-finder-header">{header}</div>}
      {topBanner && <div className="family-finder-banner">{topBanner}</div>}
      <div className="family-finder-main-grid">
        <section className="family-finder-genogram-panel">{genogram}</section>
        <aside className="family-finder-roster">{roster}</aside>
        <aside className="family-finder-search">{search}</aside>
      </div>
      <div className="family-finder-lower-grid">
        <section className="family-finder-contact">{contactTimeline}</section>
        <section className="family-finder-audit">{auditTrail}</section>
      </div>
    </div>
  );
};

export default FamilyFinderLayout;
